import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EmployeeMappingForm } from '@app/reducers/orm/integration/integration-configure.model';
import { TranslatePipe } from '@ngx-translate/core';
import { CheckboxComponent } from '@sb/ui/checkbox';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'default-employee-mapping',
  template: `
    @if (mappingForm) {
      <div class="flex flex-col gap-4">
        @if (hasControl('employee_import')) {
          <div class="flex items-center">
            <sb-checkbox [formControl]="getMappingControl('employee_import')">
              {{ 'Employee import' | translate }}
            </sb-checkbox>
          </div>
        }
        @if (hasControl('timesheet_export')) {
          <div class="flex items-center">
            <sb-checkbox [formControl]="getMappingControl('timesheet_export')">
              {{ 'Timesheet export' | translate }}
            </sb-checkbox>
          </div>
        }
        @if (hasControl('absence_export')) {
          <div class="flex items-center">
            <sb-checkbox [formControl]="getMappingControl('absence_export')">
              {{ 'Absence export' | translate }}
            </sb-checkbox>
          </div>
        }
      </div>
    }
  `,
  imports: [ReactiveFormsModule, TranslatePipe, CheckboxComponent],
})
export class DefaultEmployeeMappingComponent {
  @Input() parentForm: FormGroup;

  get mappingForm(): FormGroup<EmployeeMappingForm> | null {
    return this.parentForm.controls['default_employee_mapping'] as FormGroup<EmployeeMappingForm>;
  }

  hasControl(field: keyof EmployeeMappingForm): boolean {
    return this.mappingForm?.contains(field) ?? false;
  }

  getMappingControl(field: keyof EmployeeMappingForm): FormControl<boolean> {
    return this.mappingForm?.get(field) as FormControl<boolean>;
  }
}
